import { Controller } from "@hotwired/stimulus";

/**
 * La page Audio de la toolbox : choisir ou retirer la musique est un geste de l'éditeur (le
 * document est à lui, l'autosave le sauve), la page ne fait que le dire — événements que
 * composition-editor applique : `audio:set` / `audio:remove` sur une Composition (un morceau),
 * `audio:toggle-candidate` / `audio:remove-candidate` sur une Version de template (les
 * candidats, un morceau tiré par vidéo générée).
 *
 * Naming: "audio-page" in HTML.
 */
export default class extends Controller {
  pick(event) {
    const card = event.currentTarget;
    const track = JSON.parse(card.dataset.track);
    this.element.querySelectorAll("[role='radio']").forEach((other) => this.mark(other, other === card));
    window.dispatchEvent(new CustomEvent("audio:set", { detail: { track } }));
    this.reload();
  }

  toggle(event) {
    const card = event.currentTarget;
    const track = JSON.parse(card.dataset.track);
    this.mark(card, !card.hasAttribute("data-chosen"));
    window.dispatchEvent(new CustomEvent("audio:toggle-candidate", { detail: { track } }));
    this.reload();
  }

  removeCandidate(event) {
    window.dispatchEvent(new CustomEvent("audio:remove-candidate", { detail: { id: event.currentTarget.dataset.trackId } }));
    this.reload();
  }

  // L'état choisi se voit au clic, sans attendre la page relue (qui le confirme) : la carte
  // porte l'attribut, ses classes font le cadre.
  mark(card, chosen) {
    card.toggleAttribute("data-chosen", chosen);
    card.setAttribute("aria-checked", String(chosen));
  }

  remove() {
    window.dispatchEvent(new CustomEvent("audio:remove"));
    this.reload();
  }

  // La page se relit depuis le document : la requête du frame toolbox attend que l'autosave
  // ait mis le choix en base (Autosave, frame en attente), elle montre donc le morceau posé.
  reload() {
    this.element.closest("turbo-frame")?.reload();
  }
}
